module.exports = __webpack_public_path__ + "static/media/contact-berlin.68dbec64.png";